export const HasPermission = (permission) => {
    if(permission?.appAccess === true){
        return true;
    }
    else{
        return false;
    }
  }

export const userSecurityRole = (permission) => {
  if(permission){
    return permission;
  }
  else{
    return ""
  }
}  

export const validateFileName = (file) => {
    const fileExt = "dxf";
    const fileName = file.split(".");
    const zipFile = fileName[0].concat('.zip').trim();
    return zipFile;
};  

export const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  };



// export const downloadPdf = (response) => {
//
//     const base64String = response.data.base64String;
//     const fileName = response.data.fileName;
//     const binaryString = window.atob(base64String);
//     const bytes = new Uint8Array(binaryString.length);
//     bytes.set(Array.from(binaryString).map(char => char.charCodeAt(0)));
//     const blob = new Blob([bytes], { type: 'application/pdf' });
//
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.setAttribute('download', fileName);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
// }




// export const downloadPdf = (response) => {
//
//   const base64String = response.data.base64String;
//   const fileName = response.data.fileName;
//   const binaryString = window.atob(base64String);
//   const bytes = new Uint8Array(binaryString.length);
//   bytes.set(Array.from(binaryString).map(char => char.charCodeAt(0)));
//   const blob = new Blob([bytes], { type: 'application/html' });
//
//   const url = window.URL.createObjectURL(blob);
//   const link = document.createElement('a');
//   link.href = url;
//   link.setAttribute('download', fileName);
//   document.body.appendChild(link);
//   link.click();
//   link.remove();
// }

export const downloadPdf = (response) => {

  const base64String = response.data.base64String;
  const fileName = response.data.fileName;
  // const fileName = "Sample.html"
  const blob = new Blob([base64String], { type: 'text/html' });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
}
export const DELETE_SERVICE_ERROR_MESSAGE = "Internal service error, please try again later.";
export const APPLICATION_SERVICE_DOWN_MESSAGE = "Service temporarily unavailable We apologize for this inconvenience. Please try again later.";